module.exports = __webpack_public_path__ + "assets/fonts/MiloOffc-Light.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/milo-light/MiloOffc-Light.svg
// module id = 514
// module chunks = 0